module.exports = __webpack_public_path__ + "media/site_templates/www.tv-installation.com.au/images/our_services_2-f1d3361ac9ec086f0d369f3d7bb566ac.jpg";